export default __webpack_public_path__ + "static/media/favicon.495b7684.png";